export interface ColorMap {
  [key: string]: { mediumColor: string; lightColor: string; darkColor: string };
}

// USAGE: colorMap[selectedImprovePlan?.question?.color]?.theme)
export const colorMap: ColorMap = {
  sunYellow: { mediumColor: '#FCD300', lightColor: '#ffe665', darkColor: '#d4b202' },
  aquaGreen: { mediumColor: '#06BF97', lightColor: '#3be1ce', darkColor: '#069b7b' },
  calmLilac: { mediumColor: '#BEAAF3', lightColor: '#d4c6f9', darkColor: '#6048a1' },
  warmOrange: { mediumColor: '#FF8A4A', lightColor: '#ffaf83', darkColor: '#d96525' },
  zingyGreen: { mediumColor: '#8EEA36', lightColor: '#bbf484', darkColor: '#4c8f0c' },
  skyBlue: { mediumColor: '#019DF2', lightColor: '#3fb9fc', darkColor: '#0072b0' },
};

export const defaultColors = {
  mediumColor: '#f4f2ec',
  lightColor: '#fcfbf7',
  darkColor: '#ece7dc',
};
